import React from 'react'
import createCellEditor from './createCellEditor'
import styled from 'styled-components'

// prettier ignore
const Input = styled.input`
  border: 1px solid #4d90fe;
  text-align: center;
  ${({ width }) =>
    width &&
    `
    flex: 0 0 ${width};
    max-width: ${width};
    `};
`

const GenericEditor = ({
  editContent,
  style,
  onBlur,
  onEdit,
  refBinder,
  keyDown,
  width,
}) => (
  <Input
    width={width}
    innerRef={refBinder}
    onKeyDown={keyDown}
    onBlur={onBlur}
    style={style}
    type="text"
    value={editContent}
    onChange={e => onEdit(e.target.value)}
    data-testid="grid-cell-editor"
  />
)
//
export default createCellEditor(GenericEditor)
